/**
 * The mark: a tick sitting on a double rule.
 *
 * In bookkeeping a double rule under a figure means the total is final and checked,
 * which is what "จ่ายครบ" says in two words.
 *
 * Drawn in `currentColor` so one copy works on the buyer's coloured header, the
 * admin header, and anywhere else it ends up. The favicon is generated separately
 * in `vite.config.ts` because Vite needs it as a string at build time — that is the
 * one duplicate, and it is duplicated on purpose.
 */
export const BrandMark = ({ className }: { className?: string }) => (
  <svg viewBox="0 0 32 32" className={className} aria-hidden focusable="false">
    <g stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
      <path d="M8.5 15.6 L13.4 20.5 L23.5 9.8" strokeWidth="3.2" />
      <path d="M8.8 25 H23.2" strokeWidth="1.9" />
      <path d="M8.8 28 H23.2" strokeWidth="1.9" />
    </g>
  </svg>
)
